import { loadProject } from '../actions/project-actions';

const TIMEOUT_DELAY = 500;

function url(base, id) {
  const b = base.replace(/\/$/, '');
  return `${b}/projects/${encodeURIComponent(id)}`;
}

export default function autosaveApi(baseUrl, projectId, delay) {
  delay = delay || TIMEOUT_DELAY;
  let timeout = null;

  return (store, stateExtractor) => {
    if (!baseUrl || !projectId) return;

    fetch(url(baseUrl, projectId))
      .then((res) => (res.ok ? res.json() : null))
      .then((json) => {
        if (json && typeof json === 'object') store.dispatch(loadProject(json));
      })
      .catch(() => {});

    store.subscribe(() => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        const state = stateExtractor(store.getState());
        const body = JSON.stringify(state.scene.toJS());
        fetch(url(baseUrl, projectId), {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body,
        }).catch(() => {});
      }, delay);
    });
  };
}
